import {
    Box,
    Button,
    Text,
    Tooltip,
    useBoolean,
    useOutsideClick
} from '@chakra-ui/react'
import { useRef } from 'react'

type TxtTypes = 'SERVICO' | 'TAXA'

interface TxtGeneratorProps {
    callAPI: (type: TxtTypes) => void
    loading: boolean
}

interface ListFiles {
    text: string
    value: TxtTypes
}

export const TxtGenerator = ({ callAPI, loading }: TxtGeneratorProps) => {
    const refTooltip = useRef(null)
    const [tooltipState, setTooltipState] = useBoolean(false)
    useOutsideClick({
        ref: refTooltip,
        handler: setTooltipState.off
    })
    const files: Array<ListFiles> = [
        {
            text: 'Serviço',
            value: 'SERVICO'
        },
        {
            text: 'Taxa',
            value: 'TAXA'
        }
    ]
    const downloadCsv = (type: TxtTypes) => {
        onGenerateFile()
        callAPI(type)
    }

    const onGenerateFile = () => {
        setTooltipState.toggle()
    }

    return (
        <>
            <Tooltip
                ref={refTooltip}
                isOpen={tooltipState}
                hasArrow
                placement="bottom-start"
                backgroundColor="none"
                label={
                    <Box
                        bg="white"
                        width="150px"
                        borderRadius="8px"
                        pointerEvents="auto"
                        textAlign="center"
                        paddingY="12px"
                    >
                        <Text
                            fontSize="14px"
                            fontWeight={'bold'}
                            padding="16px 10px"
                            color="black"
                        >
                            Selecionar tipo:
                        </Text>

                        {files.map((file, index) => {
                            return (
                                <Button
                                    key={index}
                                    width="100%"
                                    height="32px"
                                    colorScheme="off-white"
                                    color="black"
                                    onClick={() => downloadCsv(file.value)}
                                    _hover={{
                                        background: 'grayscale.50'
                                    }}
                                >
                                    {file.text}
                                </Button>
                            )
                        })}
                    </Box>
                }
            >
                <Button
                    colorScheme="primary"
                    onClick={onGenerateFile}
                    isLoading={loading}
                >
                    Gerar relatório
                </Button>
            </Tooltip>
        </>
    )
}
